import localizationData from './water.en.json';
import localized from 'model/events/util';

const events = (context, setEvent) =>
  [
    {
      title: 'event.waterWildlife.title',
      outcome: 'variable',
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.waterWildlife.spring.day.description',
            effect: { resources: { morale: +1, food: +5 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.waterWildlife.spring.night.description',
            effect: { resources: { morale: +2 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.waterWildlife.summer.day.description',
            effect: { resources: { water: +10 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.waterWildlife.summer.night.description',
            effect: { resources: { ammo: +5 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.waterWildlife.autumn.day.description',
            effect: { resources: { coins: +15 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.waterWildlife.autumn.night.description',
            effect: { resources: { coins: +20 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.waterWildlife.winter.day.description',
            effect: { resources: { health: +5 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.waterWildlife.winter.night.description',
            effect: { resources: { health: +10 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'Observe',
          message: 'event.waterWildlife.button.message.observe',
          effect: {}
        },
        {
          title: 'Interact',
          message: 'event.waterWildlife.button.message.interact',
          effect: {}
        }
      ]
    },
    {
      title: 'event.weatherOverWater.title',
      outcome: 'negative',
      isBuild: true,
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.weatherOverWater.spring.day.description',
            effect: { resources: { health: -5, morale: -1 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.weatherOverWater.spring.night.description',
            effect: { resources: { health: -10, morale: -2 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.weatherOverWater.summer.day.description',
            effect: { resources: { water: -5 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.weatherOverWater.summer.night.description',
            effect: { resources: { water: -10 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.weatherOverWater.autumn.day.description',
            effect: { resources: { food: -5 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.weatherOverWater.autumn.night.description',
            effect: { resources: { food: -10 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.weatherOverWater.winter.day.description',
            effect: { resources: { ammo: -5 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.weatherOverWater.winter.night.description',
            effect: { resources: { ammo: -10 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.weatherOverWater.button.seekShelter',
          message: 'event.weatherOverWater.button.message.seekShelter',
          effect: {}
        },
        {
          title: 'event.weatherOverWater.button.pressOn',
          message: 'event.weatherOverWater.button.message.pressOn',
          effect: {}
        }
      ]
    },
    {
      title: 'event.weather2.title',
      outcome: 'variable',
      isBuild: true,
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.weather2.spring.day.description',
            effect: { resources: { health: -5 }, traits: { resilience: +1 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.weather2.spring.night.description',
            effect: { resources: { health: -10 }, traits: { luck: +1 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.weather2.summer.day.description',
            effect: { resources: { water: -10 }, traits: { resilience: +1 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.weather2.summer.night.description',
            effect: { resources: { water: -5 }, traits: { stealth: +1 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.weather2.autumn.day.description',
            effect: { resources: { ammo: -2 }, traits: { haggling: +1 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.weather2.autumn.night.description',
            effect: { resources: { health: -5 }, traits: { resilience: +1 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.weather2.winter.day.description',
            effect: { resources: { food: -10 }, traits: { resilience: +1 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.weather2.winter.night.description',
            effect: { resources: { health: -10 }, traits: { stealth: +1 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.weather2.button.takeCover',
          message: 'event.weather2.button.message.takeCover',
          effect: {}
        },
        {
          title: 'event.weather2.button.continue',
          message: 'event.weather2.button.message.continue',
          effect: {}
        }
      ]
    },
    {
      title: 'event.waterAmbush.title',
      outcome: 'negative',
      isCombat: true,
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.waterAmbush.spring.day.description',
            effect: { resources: { health: -5, ammo: -10 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.waterAmbush.spring.night.description',
            effect: { resources: { health: -10, ammo: -15 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.waterAmbush.summer.day.description',
            effect: { resources: { health: -5, ammo: -10 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.waterAmbush.summer.night.description',
            effect: { resources: { health: -10, ammo: -15 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.waterAmbush.autumn.day.description',
            effect: { resources: { health: -5, ammo: -10 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.waterAmbush.autumn.night.description',
            effect: { resources: { health: -10, ammo: -15 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.waterAmbush.winter.day.description',
            effect: { resources: { health: -5, ammo: -10 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.waterAmbush.winter.night.description',
            effect: { resources: { health: -10, ammo: -15 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.waterAmbush.button.fightBack',
          combat: {
            description: 'event.waterAmbush.button.message.fightBack',
            victory: 'event.waterAmbush.button.message.fightBack.victory',
            defeat: 'event.waterAmbush.button.message.fightBack.defeat',
            enemies: ['bandit', 'bandit', 'bandit']
          },
          effect: {}
        },
        {
          title: 'event.waterAmbush.button.evade',
          message: 'event.waterAmbush.button.message.evade',
          effect: {}
        }
      ]
    },
    {
      title: 'event.travelersOverWater.title',
      outcome: 'positive',
      state: 'encountered',
      baseWeight: 20,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.travelersOverWater.spring.day.description',
            effect: { resources: { morale: +1, food: +5, water: +5 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.travelersOverWater.spring.night.description',
            effect: { resources: { morale: +2, food: +5 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.travelersOverWater.summer.day.description',
            effect: { resources: { water: +10, food: +5 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.travelersOverWater.summer.night.description',
            effect: { resources: { ammo: +5, morale: +1 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.travelersOverWater.autumn.day.description',
            effect: { resources: { coins: +15, food: +10 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.travelersOverWater.autumn.night.description',
            effect: { resources: { coins: +20, food: +5 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.travelersOverWater.winter.day.description',
            effect: { resources: { health: +5, food: +5 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.travelersOverWater.winter.night.description',
            effect: { resources: { health: +10, food: +2 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.travelersOverWater.button.shareSupplies',
          message: 'event.travelersOverWater.button.message.shareSupplies',
          effect: {}
        },
        {
          title: 'event.travelersOverWater.button.exchangeStories',
          message: 'event.travelersOverWater.button.message.exchangeStories',
          effect: {}
        }
      ]
    },
    {
      title: 'event.hazards.title',
      outcome: 'negative',
      state: 'encountered',
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.hazards.spring.day.description',
            effect: { resources: { health: -5 }, traits: { resilience: +1 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.hazards.spring.night.description',
            effect: { resources: { health: -10 }, traits: { luck: +1 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.hazards.summer.day.description',
            effect: { resources: { water: -10 }, traits: { resilience: +1 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.hazards.summer.night.description',
            effect: { resources: { water: -5 }, traits: { stealth: +1 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.hazards.autumn.day.description',
            effect: { resources: { ammo: -2 }, traits: { haggling: +1 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.hazards.autumn.night.description',
            effect: { resources: { health: -5 }, traits: { resilience: +1 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.hazards.winter.day.description',
            effect: { resources: { food: -10 }, traits: { resilience: +1 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.hazards.winter.night.description',
            effect: { resources: { health: -10 }, traits: { stealth: +1 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.hazards.button.navigateCarefully',
          message: 'event.hazards.button.message.navigateCarefully',
          effect: {}
        },
        {
          title: 'event.hazards.button.waitItOut',
          message: 'event.hazards.button.message.waitItOut',
          effect: {}
        }
      ]
    },
    {
      title: 'event.theSea.title',
      outcome: 'positive',
      state: 'encountered',
      baseWeight: 20,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.theSea.spring.day.description',
            effect: { resources: { food: +15 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.theSea.spring.night.description',
            effect: { resources: { food: +10 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.theSea.summer.day.description',
            effect: { resources: { food: +20 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.theSea.summer.night.description',
            effect: { resources: { food: +15 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.theSea.autumn.day.description',
            effect: { resources: { food: +15 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.theSea.autumn.night.description',
            effect: { resources: { food: +10 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.theSea.winter.day.description',
            effect: { resources: { food: +10 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.theSea.winter.night.description',
            effect: { resources: { food: +5 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.theSea.button.fish',
          message: 'event.theSea.button.message.fish',
          effect: {}
        }
      ]
    },
    {
      title: 'event.waterDwellers.title',
      outcome: 'positive',
      state: 'encountered',
      baseWeight: 20,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.waterDwellers.spring.day.description',
            effect: { resources: { coins: +10 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.waterDwellers.spring.night.description',
            effect: { resources: { coins: +5 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.waterDwellers.summer.day.description',
            effect: { resources: { coins: +15 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.waterDwellers.summer.night.description',
            effect: { resources: { coins: +10 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.waterDwellers.autumn.day.description',
            effect: { resources: { coins: +10 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.waterDwellers.autumn.night.description',
            effect: { resources: { coins: +5 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.waterDwellers.winter.day.description',
            effect: { resources: { coins: +5 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.waterDwellers.winter.night.description',
            effect: { resources: { coins: +2 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.waterDwellers.button.trade',
          message: 'event.waterDwellers.button.message.trade',
          effect: {}
        }
      ]
    },
    {
      title: 'event.squall.title',
      outcome: 'negative',
      isBuild: true,
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.squall.spring.day.description',
            effect: { resources: { food: -20, water: -15 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.squall.spring.night.description',
            effect: { resources: { food: -25, water: -20 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.squall.summer.day.description',
            effect: { resources: { food: -15, water: -10 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.squall.summer.night.description',
            effect: { resources: { food: -20, water: -15 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.squall.autumn.day.description',
            effect: { resources: { food: -20, water: -15 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.squall.autumn.night.description',
            effect: { resources: { food: -25, water: -20 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.squall.winter.day.description',
            effect: { resources: { food: -10, water: -5 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.squall.winter.night.description',
            effect: { resources: { food: -15, water: -10 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.squall.button.secureCargo',
          message: 'event.squall.button.message.secureCargo',
          effect: {}
        }
      ]
    },
    {
      title: 'event.seaBreeze.title',
      outcome: 'positive',
      state: 'encountered',
      baseWeight: 20,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.seaBreeze.spring.day.description',
            effect: { resources: { health: +10 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.seaBreeze.spring.night.description',
            effect: { resources: { health: +15 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.seaBreeze.summer.day.description',
            effect: { resources: { health: +10 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.seaBreeze.summer.night.description',
            effect: { resources: { health: +15 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.seaBreeze.autumn.day.description',
            effect: { resources: { health: +10 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.seaBreeze.autumn.night.description',
            effect: { resources: { health: +15 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.seaBreeze.winter.day.description',
            effect: { resources: { health: +10 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.seaBreeze.winter.night.description',
            effect: { resources: { health: +15 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.seaBreeze.button.relax',
          message: 'event.seaBreeze.button.message.relax',
          effect: {}
        }
      ]
    },
    {
      title: 'event.storm.title',
      outcome: 'negative',
      state: 'encountered',
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.storm.spring.day.description',
            effect: { resources: { health: -5 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.storm.spring.night.description',
            effect: { resources: { health: -10 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.storm.summer.day.description',
            effect: { resources: { health: -5 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.storm.summer.night.description',
            effect: { resources: { health: -10 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.storm.autumn.day.description',
            effect: { resources: { health: -5 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.storm.autumn.night.description',
            effect: { resources: { health: -10 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.storm.winter.day.description',
            effect: { resources: { health: -5 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.storm.winter.night.description',
            effect: { resources: { health: -10 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.storm.button.seekShelter',
          message: 'event.storm.button.message.seekShelter',
          effect: {}
        }
      ]
    },
    {
      title: 'event.fishing.title',
      outcome: 'positive',
      state: 'encountered',
      baseWeight: 20,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.fishing.spring.day.description',
            effect: { resources: { food: +10 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.fishing.spring.night.description',
            effect: { resources: { food: +5 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.fishing.summer.day.description',
            effect: { resources: { food: +15 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.fishing.summer.night.description',
            effect: { resources: { food: +10 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.fishing.autumn.day.description',
            effect: { resources: { food: +10 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.fishing.autumn.night.description',
            effect: { resources: { food: +5 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.fishing.winter.day.description',
            effect: { resources: { food: +5 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.fishing.winter.night.description',
            effect: { resources: { food: +2 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.fishing.button.cook',
          message: 'event.fishing.button.message.cook',
          effect: {}
        }
      ]
    },
    {
      title: 'event.seaBandits.title',
      outcome: 'negative',
      isCombat: true,
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.seaBandits.spring.day.description',
            effect: { resources: { ammo: -10 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.seaBandits.spring.night.description',
            effect: { resources: { ammo: -15 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.seaBandits.summer.day.description',
            effect: { resources: { ammo: -10 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.seaBandits.summer.night.description',
            effect: { resources: { ammo: -15 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.seaBandits.autumn.day.description',
            effect: { resources: { ammo: -10 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.seaBandits.autumn.night.description',
            effect: { resources: { ammo: -15 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.seaBandits.winter.day.description',
            effect: { resources: { ammo: -10 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.seaBandits.winter.night.description',
            effect: { resources: { ammo: -15 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.seaBandits.button.defend',
          combat: {
            description: 'event.seaBandits.button.message.defend',
            victory: 'event.seaBandits.button.message.defend.victory',
            defeat: 'event.seaBandits.button.message.defend.defeat',
            enemies: ['bandit', 'bandit']
          }
        }
      ]
    },
    {
      title: 'event.castaways.title',
      outcome: 'positive',
      baseWeight: 20,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.castaways.spring.day.description',
            effect: { resources: { coins: +30 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.castaways.spring.night.description',
            effect: { resources: { coins: +35 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.castaways.summer.day.description',
            effect: { resources: { coins: +30 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.castaways.summer.night.description',
            effect: { resources: { coins: +35 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.castaways.autumn.day.description',
            effect: { resources: { coins: +30 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.castaways.autumn.night.description',
            effect: { resources: { coins: +35 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.castaways.winter.day.description',
            effect: { resources: { coins: +25 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.castaways.winter.night.description',
            effect: { resources: { coins: +30 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.castaways.button.help',
          message: 'event.castaways.button.message.help',
          effect: {}
        }
      ]
    },
    {
      title: 'event.iceFloes.title',
      outcome: 'negative',
      state: 'encountered',
      baseWeight: 25,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.iceFloes.spring.day.description',
            effect: { resources: { food: -10 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.iceFloes.spring.night.description',
            effect: { resources: { food: -15 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.iceFloes.summer.day.description',
            effect: { resources: { food: -5 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.iceFloes.summer.night.description',
            effect: { resources: { food: -10 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.iceFloes.autumn.day.description',
            effect: { resources: { food: -10 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.iceFloes.autumn.night.description',
            effect: { resources: { food: -15 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.iceFloes.winter.day.description',
            effect: { resources: { food: -20 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.iceFloes.winter.night.description',
            effect: { resources: { food: -25 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.iceFloes.button.conserve',
          message: 'event.iceFloes.button.message.conserve',
          effect: {}
        }
      ]
    },
    {
      title: 'event.pirates.title',
      outcome: 'negative',
      isCombat: true,
      baseWeight: 30,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.pirates.spring.day.description',
            effect: {
              resources: { food: -20, ammo: -10, coins: -40 }
            },
            weightAdjustment: 0
          },
          night: {
            description: 'event.pirates.spring.night.description',
            effect: {
              resources: { food: -25, ammo: -15, coins: -50 }
            },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.pirates.summer.day.description',
            effect: {
              resources: { food: -20, ammo: -10, coins: -40 }
            },
            weightAdjustment: -5
          },
          night: {
            description: 'event.pirates.summer.night.description',
            effect: {
              resources: { food: -25, ammo: -15, coins: -50 }
            },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.pirates.autumn.day.description',
            effect: {
              resources: { food: -20, ammo: -10, coins: -40 }
            },
            weightAdjustment: 5
          },
          night: {
            description: 'event.pirates.autumn.night.description',
            effect: {
              resources: { food: -25, ammo: -15, coins: -50 }
            },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.pirates.winter.day.description',
            effect: {
              resources: { food: -20, ammo: -10, coins: -40 }
            },
            weightAdjustment: 10
          },
          night: {
            description: 'event.pirates.winter.night.description',
            effect: {
              resources: { food: -25, ammo: -15, coins: -50 }
            },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.pirates.button.resist',
          combat: {
            description: 'event.pirates.button.resist.description',
            victory: 'event.pirates.button.resist.victory',
            defeat: 'event.pirates.button.resist.defeat',
            enemies: ['pirate', 'pirate']
          }
        }
      ]
    },
    {
      title: 'event.leaking.title',
      outcome: 'negative',
      isBuild: true,
      baseWeight: 30,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.leaking.spring.day.description',
            effect: { resources: { food: -40 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.leaking.spring.night.description',
            effect: { resources: { food: -45 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.leaking.summer.day.description',
            effect: { resources: { food: -40 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.leaking.summer.night.description',
            effect: { resources: { food: -45 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.leaking.autumn.day.description',
            effect: { resources: { food: -40 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.leaking.autumn.night.description',
            effect: { resources: { food: -45 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.leaking.winter.day.description',
            effect: { resources: { food: -40 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.leaking.winter.night.description',
            effect: { resources: { food: -45 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.leaking.button.repair',
          message: 'event.leaking.button.message.repair',
          effect: {}
        }
      ]
    },
    {
      title: 'event.crashed.title',
      outcome: 'negative',
      baseWeight: 30,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.crashed.spring.day.description',
            effect: { resources: { food: -20, ammo: -40 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.crashed.spring.night.description',
            effect: { resources: { food: -25, ammo: -50 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.crashed.summer.day.description',
            effect: { resources: { food: -20, ammo: -40 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.crashed.summer.night.description',
            effect: { resources: { food: -25, ammo: -50 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.crashed.autumn.day.description',
            effect: { resources: { food: -20, ammo: -40 } },
            weightAdjustment: 5
          },
          night: {
            description: 'event.crashed.autumn.night.description',
            effect: { resources: { food: -25, ammo: -50 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.crashed.winter.day.description',
            effect: { resources: { food: -20, ammo: -40 } },
            weightAdjustment: 10
          },
          night: {
            description: 'event.crashed.winter.night.description',
            effect: { resources: { food: -25, ammo: -50 } },
            weightAdjustment: 15
          }
        }
      ],
      buttons: [
        {
          title: 'event.crashed.button.recover',
          message: 'event.crashed.button.message.recover',
          effect: {}
        }
      ]
    },
    {
      title: 'event.seaSerpent.title',
      baseWeight: 20,
      isCombat: true,
      variants: [
        {
          season: 'spring',
          day: {
            description: 'event.seaSerpent.spring.day.description',
            effect: { resources: { health: -5 } },
            weightAdjustment: 0
          },
          night: {
            description: 'event.seaSerpent.spring.night.description',
            effect: { resources: { morale: -1 } },
            weightAdjustment: 10
          }
        },
        {
          season: 'summer',
          day: {
            description: 'event.seaSerpent.summer.day.description',
            effect: { resources: { ammo: -2 } },
            weightAdjustment: -5
          },
          night: {
            description: 'event.seaSerpent.summer.night.description',
            effect: { resources: { ammo: -3 }, traits: { stealth: +1 } },
            weightAdjustment: 5
          }
        },
        {
          season: 'autumn',
          day: {
            description: 'event.seaSerpent.autumn.day.description',
            effect: { resources: { food: -10 } },
            weightAdjustment: -10
          },
          night: {
            description: 'event.seaSerpent.autumn.night.description',
            effect: { resources: { food: -15 }, traits: { resilience: +1 } },
            weightAdjustment: 0
          }
        },
        {
          season: 'winter',
          day: {
            description: 'event.seaSerpent.winter.day.description',
            effect: { resources: { morale: -1 } },
            weightAdjustment: -15
          },
          night: {
            description: 'event.seaSerpent.winter.night.description',
            effect: { resources: { morale: -2 }, traits: { luck: +1 } },
            weightAdjustment: 10
          }
        }
      ],
      buttons: [
        {
          title: 'event.seaSerpent.button.combat',
          combat: {
            description: 'event.seaSerpent.button.combat.description',
            victory: 'event.seaSerpent.button.combat.victory',
            defeat: 'event.seaSerpent.button.combat.defeat',
            enemies: ['serpent']
          }
        },
        {
          title: 'event.seaSerpent.button.evade',
          message: 'event.seaSerpent.button.message.evade',
          effect: {}
        }
      ]
    }
  ].map(event => localized(event, localizationData));

export default events;
